import { Container, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import axios from 'axios';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useToken from '../components/UseToken';
import { FormProvider, RHFTextField } from '../components/hook-form';
import Page from '../components/Page';

export default function Advert() {
  const { token, setToken } = useToken();
  const navigate = useNavigate();

  const advertSchema = Yup.object().shape({
    text: Yup.string().required('Текст обязателен'),
    link: Yup.string().url('Это не ссылка').required('Ссылка обязательна'),
  });

  const defaultValues = {
    text: '',
    link: '',
  };

  const methods = useForm({
    resolver: yupResolver(advertSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setValue,
  } = methods;

  const onSubmit = async (data) => {
    axios
      .put('advert', data, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        toast.success(`Успешно сохранено! Возвращаемся обратно к списку...`, { autoClose: 2500 });
        setTimeout(() => navigate(`/dashboard/videos/lessons`), 3000);
      })
      .catch((err) => {
        if (err.response?.status === 401) setToken('');
        toast.error(`Ошибка: ${err.response?.data.message}`);
      });
  };

  useEffect(() => {
    axios
      .get(`advert/`)
      .then((res) => {
        setValue('text', res.data.text);
        setValue('link', res.data.link);
      })
      .catch((err) => {
        if (err.response?.status === 401) setToken('');
        toast.error(`Ошибка: ${err.response?.data.message}`);
      });
  }, []);

  return (
    <Page title="Рекламный блок">
      <Container maxWidth="lg" sx={{ ml: 0 }}>
        <Typography variant="h3">Реклама видеоурока</Typography>

        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3}>
            <RHFTextField multiline name={'text'} label={'Текст'} inputProps={{ maxLength: 94 }} />
            <RHFTextField name={'link'} label={'Ссылка'} />
            <LoadingButton
              sx={{ m: 1, alignSelf: 'end' }}
              size="medium"
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Сохранить
            </LoadingButton>
          </Stack>
        </FormProvider>
        <ToastContainer />
      </Container>
    </Page>
  );
}
